import React, { useEffect, useState } from "react";
import { Navbar } from "../../Components/Navbar";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Card from '@mui/material/Card';
// import SearchIcon from '@mui/icons-material/Search';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { getBCPresets, getBCPresetsFilterData, setOnchangeImportPreset } from "../../redux/actions/BookClosure/actionBookClosure";
import { getOneBookClosure, importTaskFormPreset } from "../Services/ApiHandler";
import swal from "sweetalert";
import { toast } from "react-toastify";
import Loader from "../../helper/loader";
import { motion } from "framer-motion";

import Sidebar from "../../myfin_v2/elements/Sidebar"
import commoncss from "../../myfin_v2/css/common.module.css"
import buttoncss from "../../myfin_v2/css/button.module.css"
import Breadcrumb from "../../myfin_v2/components/Breadcrumb"
import { Button } from "../../myfin_v2/elements/Button"
import ModuleCard from "../../myfin_v2/elements/ModuleCard"
import "../../myfin_v2/css/module.css"
import InputGroup from "../../myfin_v2/elements/InputGroup";
import { ReactComponent as PlusIcon } from "../../myfin_v2/assets/icons/plus.svg";
import { ReactComponent as RoundedCheckIcon } from "../../myfin_v2/assets/icons/rounded_check.svg";
import { ReactComponent as SearchIcon } from "../../myfin_v2/assets/icons/search.svg";


const ImportPreset = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { workspaceId, companyId } = useParams();

    const {
        presets,
        presetsRef,
        loading,
        errorMessage,
    } = useSelector((state) => state.BookClosurePresetReducer);

    const {
        bookClosureId,
    } = useSelector((state) => state.BookClosureReducer);

    const [searchText, setSearchText] = useState("")
    useEffect(() => {
        if (!bookClosureId) {
            getBookClosureData();
        }
    }, []);

    useEffect(() => {
        dispatch(getBCPresets(1,workspaceId));
    }, [dispatch]);

    const getBookClosureData = () => {
        const data = {
            companies: [companyId],
        }
        getOneBookClosure(workspaceId, data).then(response => {
            dispatch({ type: "BOOK_cLOSURE_DATA", payload: response.data.bookClosure || {} });
        }).catch(error => {
            swal("Error", `Book Closure Error: ${error.response?.data?.error}`, 'error');
        })
    }

    const onChecked = (e, index) => {
        dispatch(setOnchangeImportPreset(index, e.target, presets));
    }

    // const updatePreset = (name, index) => {


    //     presets[index][name] = !presets[index][name];
    //     if (name === "isPresetChecked") {
    //         presets[index]["presetID"] = presets[index][name] ? presets[index]?._id : ""
    //     }
    //     console.log("presets", presets);

    //     return dispatch => {
    //         dispatch({
    //             type: "UPDATE_PRESET_FETCH_DATA",
    //             payload: presets,
    //         });
    //     };
    // }

    const updatePreset = (name, index) => {
        // Make a shallow copy of presets array
        const updatedPresets = [...presets];

        // Make a shallow copy of the object you're updating
        const updatedPreset = { ...updatedPresets[index] };

        // Toggle the field
        updatedPreset[name] = !updatedPreset[name];

        // Conditionally set presetID
        if (name === "isPresetChecked") {
            updatedPreset["presetID"] = updatedPreset[name] ? updatedPreset._id : "";
        }

        // Replace the object in the array
        updatedPresets[index] = updatedPreset;

        // Dispatch the updated array
        dispatch({
            type: "UPDATE_PRESET_FETCH_DATA",
            payload: updatedPresets,
        });
    };

    const ImportPresetFromTask = () => {
        const filterData = presets.filter(data => data?.presetID);

        if (filterData.length <= 0) {
            // toast.warning("Please select at least one preset for import.");
            swal("Warning", "Please select at least one preset for import.", "warning");
            return;
        }
        if (filterData.length > 1) {
            // toast.warning("Only one preset can be imported at a time.");
            swal("Warning", "Only one preset can be imported at a time.", "warning");
            return;
        }

        const dataForImport = filterData[0];

        const data = {
            // required keys
            "workspaceID": workspaceId,
            "bookClosureID": bookClosureId,
            "companyID": companyId,
            "presetID": dataForImport.presetID,
            // optional keys
            "tasks": true,
            "assignee": dataForImport.assignee,
            "approver": dataForImport.approver,
            "template": dataForImport.template,
            "templateAmount": dataForImport.templateAmount,
            "FSCPEntries": dataForImport.FSCPEntries,
            "FSCPEntriesAmount": dataForImport.FSCPEntriesAmount
        }

        importTaskFormPreset(data).then(response => {
            // toast.success("Preset Imported Successfully.");
            swal("Success", "Preset Imported Successfully.", 'success')
            history.push(`/bookclosure/${workspaceId}`);
        }).catch(error => {
            swal("Error", error.response?.data?.error || "Import Task Failed!", 'error');
        })

    }

    const handleSearchChange = (e) => {
        const value = e.target.value
        setSearchText(value)
        if (value.length > 0) {
            const filtered = presetsRef.filter(preset =>
                preset.name.toLowerCase().includes(value.toLowerCase())
            );
            dispatch(getBCPresetsFilterData(filtered));
        } else {
            dispatch(getBCPresetsFilterData(presetsRef));
        }
    }

    const breadcrumbItems = [
        {
            label: "Workspace",
            // link: `/bookclosure/${workspaceId}`,
            link: {
                pathname: `/bookclosure/${workspaceId}`,
                state: { redirectFilter: { companyID: companyId } }
            },
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
            label: "Book closure",
            // link: `/bookclosure/${workspaceId}`,
            link: {
                pathname: `/bookclosure/${workspaceId}`,
                state: { redirectFilter: { companyID: companyId } }
            },
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        { label: "Import from Existing Presets", link: "", className: "headerLable" },
    ];

    console.log("presets",presets);
    

    return (
        <>
            <div className={commoncss.pageLayout}>
                <Sidebar />
                <motion.div
                    initial={{ y: -100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 0, opacity: 0 }}
                    transition={{ duration: 0.5, ease: "easeInOut" }} className={`${commoncss.pageContent} ${commoncss.bgClr1} `}>
                    <Breadcrumb
                        addCls={"bgClr1"}
                        items={breadcrumbItems}
                        headerActions={<></>}
                    />
                    {
                        loading ? <Loader /> :
                            errorMessage ? <p className="w-100 text-center text-danger">{errorMessage}</p> :
                                (
                                    <div className="library-container">
                                        <div className="moduleHeader">
                                            <h2 className="moduleHeaderTitle m-1">Import Presets</h2>
                                            <div className="selected-info vaMiddle">
                                                <InputGroup
                                                    width={"400px"}
                                                    class_="mb-0"
                                                    inputs={[
                                                        <>
                                                            <span className={commoncss.imgIconInput}>
                                                                <span className="icon" style={{ cursor: "pointer", pointerEvents: "auto", marginTop: "-2" }} >
                                                                    <SearchIcon
                                                                        className="vaMiddle"
                                                                        width={17}
                                                                        height={17}
                                                                    />
                                                                </span>
                                                                <input type="text" value={searchText} placeholder="Search by preset name" onChange={(e) => { handleSearchChange(e) }} />
                                                            </span>
                                                        </>,
                                                    ]}
                                                />
                                                <Button
                                                    label="Import Presets"
                                                    btnColor={buttoncss.primary}
                                                    icon={<PlusIcon />}
                                                    onClick={ImportPresetFromTask}
                                                />
                                            </div>
                                        </div>
                                        <div className="modulecards-grid">
                                            {
                                                presets && presets.length > 0 && presets.map((preset, index) => {
                                                    const colIndex = index % 5; // 0-based column index in 5-column layout

                                                    // Define variation sets
                                                    const leftToRightVariants = [
                                                        { x: -120, y: -10, duration: 0.4 },
                                                        { x: -100, y: 5, duration: 0.6 },
                                                        { x: -150, y: 15, duration: 0.5 }
                                                    ];

                                                    const rightToLeftVariants = [
                                                        { x: 120, y: -10, duration: 0.4 },
                                                        { x: 100, y: 10, duration: 0.6 },
                                                        { x: 140, y: 20, duration: 0.5 }
                                                    ];

                                                    const middleColumnVariants = [
                                                        { x: -80, y: 0, duration: 0.5 },
                                                        { x: 80, y: 0, duration: 0.5 },
                                                        { x: 0, y: -100, duration: 0.6 },
                                                        { x: 0, y: 100, duration: 0.4 },
                                                        { x: -100, y: -100, duration: 0.7 }
                                                    ];

                                                    // Pick variant based on column
                                                    let variant;
                                                    if (colIndex <= 1) {
                                                        variant = leftToRightVariants[index % leftToRightVariants.length];
                                                    } else if (colIndex >= 3) {
                                                        variant = rightToLeftVariants[index % rightToLeftVariants.length];
                                                    } else {
                                                        variant = middleColumnVariants[index % middleColumnVariants.length];
                                                    }
                                                    return (
                                                        <>
                                                            <motion.div
                                                                initial={{ x: variant.x, y: variant.y, opacity: 0 }}
                                                                animate={{ x: 0, y: 0, opacity: 1 }}
                                                                transition={{ duration: variant.duration, ease: "easeOut" }} className={`modulecard clickable ${preset?.isPresetChecked ? 'active-module' : ""}`} key={index}
                                                                onClick={(e) => { updatePreset("isPresetChecked", index); }}
                                                            >
                                                                <span className="module-toggles">
                                                                    <h2 className="card-title" name="isPresetChecked">{preset?.name}</h2>

                                                                    {/* <label className="toggle-label mb-0  " >{preset?.name}</label> */}

                                                                    {/* <div className="toggle-item mt-3">
                                                                        <div className={`toggle-container`}>
                                                                            <label className="switch_sm">
                                                                                <input type="checkbox"
                                                                                    checked={preset?.tasks}
                                                                                    name="tasks"
                                                                                    id={`flexCheckDefault${index}`}
                                                                                    style={{ width: "23px", height: "23px" }}
                                                                                    onClick={(e) => onChecked(e, index)} />
                                                                                <span className="slider_sm round"></span>
                                                                            </label>
                                                                            <label className="toggle-label mb-0  " for={`flexCheckDefault${index}`} >Tasks</label>
                                                                        </div>
                                                                    </div> */}

                                                                    <div className="toggle-item mt-3">
                                                                        <div className={`toggle-container`}>
                                                                            <label className="switch_sm">
                                                                                <input type="checkbox"
                                                                                    checked={preset?.template}
                                                                                    name="template"
                                                                                    id={`flexCheckDefault`}
                                                                                    style={{ width: "23px", height: "23px" }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();          
                                                                                        onChecked(e, index);          
                                                                                        if (!preset.isPresetChecked) {
                                                                                            updatePreset("isPresetChecked", index);
                                                                                        }; 
                                                                                    }}
                                                                                    />
                                                                                <span className="slider_sm round"></span>
                                                                            </label>
                                                                            <label className={`toggle-label mb-0   ${commoncss.flexCenter} ${commoncss.textLabel}`} for={`flexCheckDefault${index}`} >Templates

                                                                                {preset?.template && (
                                                                                    <>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            style={{ margin: "0px !important", width: "15px", height: "15px", margin: "0px 5px", marginLeft: "38px" }}

                                                                                            checked={preset?.templateAmount}
                                                                                            name="templateAmount"
                                                                                            onClick={(e) => { e.stopPropagation(); onChecked(e, index) }}
                                                                                        />
                                                                                        <label className={`form-check-label font-sans ml-1 ${commoncss.primaryLabel}`}>
                                                                                            with amount
                                                                                        </label>
                                                                                    </>
                                                                                )}
                                                                            </label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="toggle-item">
                                                                        <div className={`toggle-container`}>
                                                                            <label className="switch_sm">
                                                                                <input type="checkbox"
                                                                                    checked={preset?.FSCPEntries}
                                                                                    name="FSCPEntries"
                                                                                    id={`flexCheckDefault`}
                                                                                    style={{ width: "23px", height: "23px" }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();          
                                                                                        onChecked(e, index);          
                                                                                        if (!preset.isPresetChecked) {
                                                                                            updatePreset("isPresetChecked", index);
                                                                                        };  
                                                                                    }}
                                                                                    />
                                                                                <span className="slider_sm round"></span>
                                                                            </label>
                                                                            <label className={`toggle-label mb-0   ${commoncss.flexCenter} ${commoncss.textLabel}`} for={`flexCheckDefault`} >FSCP Entries


                                                                                {preset?.FSCPEntries && (
                                                                                    <>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            style={{ margin: "0px !important", width: "15px", height: "15px", margin: "0px 5px", marginLeft: "24px" }}
                                                                                            checked={preset?.FSCPEntriesAmount}
                                                                                            name="FSCPEntriesAmount"
                                                                                            onClick={(e) => { e.stopPropagation(); onChecked(e, index) }}
                                                                                        />
                                                                                        <label className={`form-check-label font-sans ml-1 ${commoncss.primaryLabel}`}>
                                                                                            with amount
                                                                                        </label>
                                                                                    </>
                                                                                )}</label>

                                                                        </div>
                                                                    </div>

                                                                    <div className="toggle-item">
                                                                        <div className={`toggle-container`}>
                                                                            <label className="switch_sm">
                                                                                <input type="checkbox"
                                                                                    checked={preset?.assignee}
                                                                                    name="assignee"
                                                                                    id={`flexCheckDefault`}
                                                                                    style={{ width: "23px", height: "23px" }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();          
                                                                                        onChecked(e, index);          
                                                                                        if (!preset.isPresetChecked) {
                                                                                            updatePreset("isPresetChecked", index);
                                                                                        };  
                                                                                    }}
                                                                                    />
                                                                                <span className="slider_sm round"></span>
                                                                            </label>
                                                                            <label className="toggle-label mb-0  " for={`flexCheckDefault`} >Assignee</label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="toggle-item">
                                                                        <div className={`toggle-container`}>
                                                                            <label className="switch_sm">
                                                                                <input type="checkbox"
                                                                                    checked={preset?.approver}
                                                                                    name="approver"
                                                                                    id={`flexCheckDefault`}
                                                                                    style={{ width: "23px", height: "23px" }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();          
                                                                                        onChecked(e, index);          
                                                                                        if (!preset.isPresetChecked) {
                                                                                            updatePreset("isPresetChecked", index);
                                                                                        };  
                                                                                    }}
                                                                                    />
                                                                                <span className="slider_sm round"></span>
                                                                            </label>
                                                                            <label className="toggle-label mb-0  " for={`flexCheckDefault`} >Approver</label>
                                                                        </div>
                                                                    </div>

                                                                </span>
                                                            </motion.div>
                                                        </>
                                                    )

                                                })}
                                        </div>
                                    </div>
                                )
                    }
                </motion.div>
            </div>
        </>
    );
};

export default ImportPreset;
